import React, {Component} from 'react';
import EmptyResults from 'app/components/articles/EmptyResults';
import {inject, observer} from 'mobx-react';
import Preview from 'app/components/pages/articles/Preview';
import SmartFullPageLoader from 'app/components/reusable/smart_loaders/SmartFullPageLoader';
import ArticleInterface from 'app/interfaces/articles/ArticleInterface';
import {GAMER_2} from 'app/utils/Consts';

interface ArticlesByLastProps {
    articles: ArticleInterface[]
    type?: string
}

@inject('articlesStore')
@observer
export default class ArticlesByLast extends Component<ArticlesByLastProps> {
    state = {loading: false};

    groupedArticles = (articles: ArticleInterface[]): ArticleInterface[][] => {
        const grouped = [];

        for (let i = 0; i < articles.length; i += GAMER_2) {
            grouped.push(articles.slice(i, i + GAMER_2));
        }
        return grouped;
    };

    render(): React.ReactNode {
        const {loading} = this.state;
        const {articles, type} = this.props;
        const grouped = this.groupedArticles(articles);

        return <>
            { loading
                ? <SmartFullPageLoader/>
                : <><div className="content__holder news-wrapper news-wrapper-last">
                    {articles.length > 0
                        ? grouped.map((pair, index) => <div key={index} className="article--preview-row">
                            {pair.map(article => <Preview key={article.id} data={article} type={type || 'news'}/>)}
                        </div>)
                        : <EmptyResults/>}
                </div></>
            }
        </>;
    }
}
